import axios, {
	AxiosRequestConfig,
	AxiosResponse,
} from 'axios';

/**전역 로그*/
function log(title: String, message: any = null) {
	// if (message == null) {
	// 	console.log('[' + title + '] ');
	// } else {
	// 	console.groupCollapsed('[' + title + '] ');
	// 	console.info(message);
	// 	console.groupEnd();
	// }
}

/** response logging*/
function responseLog(res: AxiosResponse) {
	const color =
		res.status != null &&
		res.status != undefined &&
		(res.status === 200 || res.status === 201)
			? '#58FA58'
			: '#FA5858';

	console.groupCollapsed(
		`[Axios] %c[${res.status ?? 'timeout'}]`,
		`background-color:${color}; color:black`,
		`- ${res.config.url ?? ''}`
	);
	console.info(`url: ${res.config.url ?? ''}`);
	console.info(
		'[Request]\n',
		'\theaders: ',
		res.headers || '',
		'\n',
		'\tdata: ',
		res.data || ''
	);
	console.groupEnd();
}

// 	/** api process logging*/
function processLog({
	url,
	stat,
	params,
	body,
	contentType,
	header,
	isError = false,
}: {
	url: string;
	stat: string;
	params?: string[];
	body?: Map<string, any>;
	contentType?: string;
	header?: any;
	isError?: boolean;
}) {
	const color = isError ? '#ED2877' : '#81BEF8';

	console.groupCollapsed(
		`[Axios] %c[${stat}]`,
		`background-color:${color}; color:white`,
		`- ${url ?? ''}`
	);
	console.info(
		'[Request]\n',
		'header: ',
		header ??
			({
				'Content-Type':
					contentType ?? 'application/json',
			} ||
				''),
		'\n',
		'params: ',
		params || '',
		'\n',
		'body: ',
		body
	);
	console.groupEnd();
}

// class log {
// 	/**전역 로그*/
// 	static appLog(
// 		title: String,
// 		message: any = null
// 	) {
// 		if (message == null) {
// 			console.log('[' + title + '] ');
// 		} else {
// 			console.groupCollapsed('[' + title + '] ');
// 			console.info(message);
// 			console.groupEnd();
// 		}
// 	}
// 	/** response logging*/
// 	static responseLog(res: AxiosResponse) {
// 		const color =
// 			res.status != null &&
// 			res.status != undefined &&
// 			(res.status === 200 || res.status === 201)
// 				? '#58FA58'
// 				: '#FA5858';

// 		console.groupCollapsed(
// 			`[Axios] %c[${res.status ?? 'timeout'}]`,
// 			`background-color:${color}; color:black`,
// 			`- ${res.config.url ?? ''}`
// 		);
// 		console.info(`url: ${res.config.url ?? ''}`);
// 		console.info(
// 			'[Request]\n',
// 			'\theaders: ',
// 			res.headers || '',
// 			'\n',
// 			'\tdata: ',
// 			res.data || ''
// 		);
// 		console.groupEnd();
// 	}

// 	/** api process logging*/
// 	static processLog({
// 		url,
// 		stat,
// 		params,
// 		body,
// 		contentType,
// 		header,
// 		isError = false,
// 	}: {
// 		url: string;
// 		stat: string;
// 		params?: string[];
// 		body?: Map<string, any>;
// 		contentType?: string;
// 		header?: any;
// 		isError?: boolean;
// 	}) {
// 		const color = isError ? '#ED2877' : '#81BEF8';

// 		console.groupCollapsed(
// 			`[Axios] %c[${stat}]`,
// 			`background-color:${color}; color:white`,
// 			`- ${url ?? ''}`
// 		);
// 		console.info(
// 			'[Request]\n',
// 			'header: ',
// 			header ??
// 				({
// 					'Content-Type':
// 						contentType ?? 'application/json',
// 				} ||
// 					''),
// 			'\n',
// 			'params: ',
// 			params || '',
// 			'\n',
// 			'body: ',
// 			body
// 		);
// 		console.groupEnd();
// 	}
// }
export default log;
export { responseLog, processLog };
